import { render } from "./DefH2.vue?vue&type=template&id=15f4c8fe&scoped=true"
import script from "./DefH2.vue?vue&type=script&lang=js"
export * from "./DefH2.vue?vue&type=script&lang=js"

import "./DefH2.vue?vue&type=style&index=0&id=15f4c8fe&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f4c8fe"]])

export default __exports__